import { ColDef, GridOptions } from '@ag-grid-community/core'
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core'
import {
  disableChangeDetectionOnScroll,
  enableHeliosCopyBehavior,
  enableHeliosGridDensityLevel,
} from '@helios/ag-grid-config'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { AccountDetailsKey } from '@helios/panels/account-details'
import {
  DensityLevel,
  UserPreferencesService,
  WorkspaceGridSavedViewService,
} from '@helios/user-preferences'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import {
  SleeveDetails,
  SleeveDetailsField,
} from '../../models/sleeve-details.model'
import { SleeveDetailsService } from '../../services/sleeve-details.service'

@Component({
  selector: 'hs-sleeve-details-grid',
  templateUrl: './sleeve-details-grid.component.html',
  styleUrls: ['./sleeve-details-grid.component.scss'],
})
export class SleeveDetailsGridComponent implements OnDestroy {
  /**
   * DO NOT CHANGE. Saved Views and Filter Groups depend on this key. Changing will result in users losing their saved
   * preferences for this grid.
   */
  SleeveDetailsGridKey = `${AccountDetailsKey}-sleeveDetailsGrid`
  constructor(
    public sleeveDetailsService: SleeveDetailsService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly preferences: UserPreferencesService,
    private readonly savedViewService: WorkspaceGridSavedViewService,
  ) {}
  @Output() showSleeveDetailsEmitter = new EventEmitter<boolean>()
  sleeveDetailsData: SleeveDetails[] = []
  loading = false
  private readonly colDefsSleeveDetails: ColDef[] =
    this.createColumnDefsSleeveDetails()
  gridOptionsSleeveDetails: GridOptions = this.createGridOptionsSleeveDetails()

  private readonly destroySubject$ = new Subject<void>()

  @Input()
  set accountSelectionChanged(accountId: number | undefined) {
    if (accountId != undefined) {
      this.loading = true
      this.getSleeveDetails(accountId)
    }
  }

  ngOnDestroy(): void {
    this.destroySubject$.next()
    this.destroySubject$.complete()
  }

  createColumnDefsSleeveDetails(): ColDef[] {
    return [
      {
        field: SleeveDetailsField('accountType'),
        headerName: 'Account Type',
        width: 500,
      },
      {
        field: SleeveDetailsField('id'),
        headerName: 'AccountId',
        width: 300,
      },
      {
        field: SleeveDetailsField('name'),
        headerName: 'Account Name',
        width: 500,
      },
    ]
  }
  private createGridOptionsSleeveDetails(): GridOptions {
    return {
      sideBar: false,
      columnDefs: this.colDefsSleeveDetails,
      ...disableChangeDetectionOnScroll(this.changeDetector),
      onGridReady: params => {
        this.savedViewService.manageSavedView(
          params,
          this.SleeveDetailsGridKey,
          this.destroySubject$,
        )
        this.preferences
          .getDensityLevel()
          .pipe(takeUntil(this.destroySubject$))
          .subscribe(level =>
            enableHeliosGridDensityLevel(
              params.api,
              DensityLevel.Compact === level,
            ),
          )
        enableHeliosCopyBehavior(params.api)
      },
    }
  }
  async getSleeveDetails(accountId: number) {
    this.sleeveDetailsData = await this.sleeveDetailsService
      .getSleeveDetails(accountId.toString())
      .toPromise()
    this.loading = false
    if (this.sleeveDetailsData.length == 0)
      this.showSleeveDetailsEmitter.emit(false)
  }
}
